import React, { forwardRef } from "react";
import { node } from "prop-types";

import * as S from "./styled";

const ContactGroup = forwardRef(({ children, ...props }, ref) => (
  <S.ContactGroup ref={ref} {...props}>
    {React.Children.map(children, child => (
      <S.ContactGroupItem>{child}</S.ContactGroupItem>
    ))}
  </S.ContactGroup>
));

ContactGroup.propTypes = {
  children: node.isRequired
};

export default ContactGroup;
